<span class="rcp-list-flt-content">
    <span class="rcp-list-filter-txt">Filter By: </span>
      <one-filtering-chip    
        [list]="sourceList"
        [placeholder]="sourcePlaceholder"
        [formControl]="sourceFormControl"
        [width]="width">
      </one-filtering-chip>
      &nbsp;
      <one-filtering-chip    
        [list]="warningsList"
        [placeholder]="warningPlaceholder"
        [formControl]="warningFormControl"
        [width]="width">
      </one-filtering-chip>      
</span>
<!-- mat-form-field -->